export default {
  EBG_CROCODILE: 2,
  EBG_COBRA: 3,
  EBG_SCORPIO: 4,
};
